module.exports = __webpack_public_path__ + "assets/img/39c5-am.svg";